import { createContext, useContext, useState, useRef } from 'react';
import moment from 'moment';

const UserActivityContext = createContext();

export const useUserActivity = () => {
	const context = useContext(UserActivityContext);
	if (!context) {
		throw new Error('useUserActivity must be used within a UserActivityProvider');
	}
	return context;
};

export const UserActivityProvider = ({ children }) => {
	const [lastActivityTimestamp, setLastActivityTimestamp] = useState(moment());
	const lastActivityRef = useRef(null);

	const updateActivity = (timestamp = moment()) => {
		lastActivityRef.current = timestamp;
        console.log('updateActivity', timestamp);
		setLastActivityTimestamp(timestamp);
	};

	const getLastActivity = () => lastActivityRef.current;

	const value = {
		lastActivityTimestamp,
		updateActivity,
		getLastActivity,
	};

	if (typeof window !== 'undefined') {
        window.ai_chat ??= {};
		window.ai_chat.contexts ??= {}
        window.ai_chat.contexts.userActivity = {
			updateActivity,
			getLastActivity,
		};
	}

	return (
		<UserActivityContext.Provider value={value}>
			{children}
		</UserActivityContext.Provider>
	);
};
